import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './UIConsumer/App';
import './index.css';
import './productsStyles.css';
import './categoriesStyles.css';
import './headerStyles.css';
import './mobileSearchBarStyles.css'
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <App />
  </React.StrictMode>
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
